














import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Menu as InnerMenu } from '../../blocks';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { settingsRoutes } from '@/pages/profile/router';
import { MenuData } from '@/pages/profile/blocks';
import { ACTIONS } from '@/store/user';
import { INFO_TEXT, FORM_SUCCESS_MESSAGE, FORM_ERROR_MESSAGE } from './consts';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { Errors } from './types';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    InnerMenu,
    LoadingSpinner,
  },
})
export default class Setting extends Vue {
  readonly menu: MenuData = settingsRoutes;

  errorColor = false;
  isSubmitingForm = false;
  messageText: string = INFO_TEXT;
  errors: Array<Errors> = [];

  get loading() {
    return this.user.loading;
  }

  get state() {
    return this.$store.state;
  }

  get user() {
    return this.state.user;
  }

  get profile() {
    return this.user.profile;
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    this.resetText();
    next();
  }

  resetText() {
    if (this.messageText !== INFO_TEXT) this.messageText = INFO_TEXT;
    if (this.errorColor) this.errorColor = false;
  }

  submit(value: any) {
    if (!Object.values(value).length) return;

    this.isSubmitingForm = true;
    this.$store
      .dispatch(`user/${ACTIONS.UPDATE_PROFILE}`, value)
      .then(() => {
        this.isSubmitingForm = false;
        this.messageText = FORM_SUCCESS_MESSAGE;
        this.errorColor = false;
        this.errors.splice(0, this.errors.length);
      })
      .catch((err: any) => {
        this.errorColor = true;
        this.isSubmitingForm = false;
        this.messageText = FORM_ERROR_MESSAGE;

        if (!isArrayNotEmpty(err)) return;
        this.errors = err;
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/settings/Settings.vue